<div  role="group"
      class="app-custom-mat-cat-container"
      [formGroup]="parts"
      [attr.aria-describedby]="describedBy"
      [attr.aria-labelledby]="parentFormField?.getLabelId()"
      (focusin)="onFocusIn($event)"
      (focusout)="onFocusOut($event)">
    <input class="app-custom-mat-cat-element" 
      formControlName="area"
      maxlength="3"
      size="3"
      (input)="_handleInput(parts.controls.area, exchange)"
      #area>
    <span class="app-custom-mat-cat-spacer">&ndash;</span>
    <input 
      class="app-custom-mat-cat-element"
      formControlName="exchange"
      maxlength="10"
      (input)="_handleInput(parts.controls.exchange)"
      (keyup.backspace)="autoFocusPrev(parts.controls.exchange, area)"
    #exchange>
    <!--
    <input 
      class="app-custom-mat-cat-element"
      formControlName="subscriber"
      maxlength="4"
      size="3"
      (input)="_handleInput(parts.controls.subscriber)"
      (keyup.backspace)="autoFocusPrev(parts.controls.subscriber, exchange)"
      #subscriber> -->
  </div>